import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { gql, useQuery } from '@apollo/client'
import { Spin, Modal } from 'antd'

import AddressFormContainer from '../../Customers/ShippingAddresses/AddressFormContainer'

// The selected contact's own shipping addresses. Mirrors the query used by the
// legacy ShippingAddressListOptions, rendered here as the design's cards.
const SHIPPING_ADDRESSES_QUERY = gql`
  query CustomerShippingAddresses($customerNo: String!, $perPage: Int) {
    customer(customerNo: $customerNo) {
      id
      shippingAddresses(perPage: $perPage) {
        id
        fullAddress
        contactName
        contactNumber
      }
    }
  }
`

// Card-based shipping-address selector matching the Company Add Order mock,
// wired to the chosen contact's real addresses. Add/edit reuse the existing
// AddressFormContainer; `refetch`/`setRefetch` let the parent trigger a reload
// after it saves a new address from its own "+ เพิ่มที่อยู่" modal.
const CompanyShippingAddressPicker = ({
    customerId,
    value,
    onChange,
    refetch,
    setRefetch
}) => {
    const { loading, data, refetch: refetchQuery } = useQuery(SHIPPING_ADDRESSES_QUERY, {
        variables: { customerNo: customerId, perPage: 50 }
    })

    const [editId, setEditId] = useState(null)
    const [showForm, setShowForm] = useState(false)

    useEffect(() => {
        if (refetch) {
            refetchQuery()
            setRefetch(false)
        }
    }, [refetch])

    if (loading) return <Spin />

    const addresses = (data && data.customer && data.customer.shippingAddresses) || []

    const openEdit = (e, id) => {
        e.preventDefault()
        e.stopPropagation()
        setEditId(id)
        setShowForm(true)
    }

    const onSaveSuccess = () => {
        setShowForm(false)
        setEditId(null)
        refetchQuery()
    }

    if (addresses.length === 0) {
        return <div className="note-line">ยังไม่มีที่อยู่จัดส่งสำหรับผู้ติดต่อนี้ — กด “+ เพิ่มที่อยู่”</div>
    }

    return (
        <div className="addr-list">
            {addresses.map((a) => {
                const selected = value === a.id
                return (
                    <div
                        key={a.id}
                        className={selected ? 'addr-card addr-card--on' : 'addr-card'}
                        onClick={() => onChange(a.id)}>
                        <span className={selected ? 'dot dot--on' : 'dot'} style={{ marginTop: 3 }} />
                        <div className="addr-body">
                            <span className="addr-name">{a.contactName || '-'}</span>
                            <span className="addr-detail">{a.fullAddress}</span>
                            <span className="addr-phone">เบอร์ติดต่อ: {a.contactNumber || '-'}</span>
                        </div>
                        <a className="addr-edit" href="#" onClick={(e) => openEdit(e, a.id)}>แก้ไข</a>
                    </div>
                )
            })}

            <Modal
                open={showForm}
                footer={null}
                width="65%"
                destroyOnClose
                onCancel={() => { setShowForm(false); setEditId(null) }}>
                <h2>แก้ไขที่อยู่จัดส่ง</h2>
                <AddressFormContainer
                    customerId={customerId}
                    shippingAddressId={editId}
                    showSubmitBtn
                    onSuccess={onSaveSuccess}
                />
            </Modal>
        </div>
    )
}

CompanyShippingAddressPicker.propTypes = {
    customerId: PropTypes.string.isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func,
    refetch: PropTypes.bool,
    setRefetch: PropTypes.func
}

CompanyShippingAddressPicker.defaultProps = {
    onChange: () => {},
    refetch: false,
    setRefetch: () => {}
}

export default CompanyShippingAddressPicker
